import { takeLatest, call, put, take } from "typed-redux-saga/macro";
import {
  GET_PRODUCT_GROUP_COMPONENTS,
  ProductGroupComponent,
  GetProductGroupComponentsAction,
} from "./ProductGroupComponentsTypes";
import { callApi } from "utils/SagaUtils";
import { getData } from "services/ApiService";
import { acquireEndpoint } from "utils/SmartMerchandiserAPI";
import { loadProductsFromCategory } from "store/product-list/ProductListActions";
import { FETCH_PRODUCT_LIST } from "store/product-list/ProductListTypes";
import { productGroupComponentsLoading } from "./ProductGroupComponentsActions";

function* getProductGroupComponents(action: GetProductGroupComponentsAction) {
  yield* put(productGroupComponentsLoading(true));
  const { productId, storeId, localeCode, categoryId, catalogId } =
    action.payload;
  const actionType = GET_PRODUCT_GROUP_COMPONENTS;
  const constName = Object.keys({ GET_PRODUCT_GROUP_COMPONENTS })[0].toString();
  const endpoint = acquireEndpoint(constName, productId);
  const headers = {
    "x-store-id": storeId,
    "x-locale-code": localeCode,
  };
  try {
    const response = yield* call(
      callApi,
      actionType,
      getData,
      null,
      endpoint,
      headers,
    );
    if (response.type === actionType.SUCCESS && response.payload) {
      let productIds: string[] = [
        productId,
        ...(response.payload.components?.map(
          (component: ProductGroupComponent) => component.productId,
        ) ?? []),
      ];

      yield* put(
        loadProductsFromCategory({
          productIds,
          storeId,
          localeCode,
          categoryId,
          catalogId,
          storeListIds: [],
          isRefreshingFromProductGroupMgmt: true,
        }),
      );

      // Wait for loadProductsFromCategory to complete
      yield* take(FETCH_PRODUCT_LIST.SUCCESS);

      yield* put(productGroupComponentsLoading(false));
    }
  } catch (error) {
    yield* put({ type: actionType.FAILURE, message: error });
    yield* put(productGroupComponentsLoading(false));
  }
}

export function* watchProductGroupComponents() {
  yield* takeLatest(
    GET_PRODUCT_GROUP_COMPONENTS.REQUEST,
    getProductGroupComponents,
  );
}
